/**
 * Blog Toggle Handler
 * Handles expand/collapse functionality for blog sections with "View All" buttons
 *
 * Usage: Add data attributes to button element:
 * - data-blog-toggle="true"
 * - data-hidden-class="your-hidden-class"
 * - data-item-selector="[data-your-attr='1']"
 * - data-index-attr="data-your-index"
 * - data-text-show="See All Items"
 * - data-text-hide="Hide Items"
 * - data-label-show="Expand to show all items"
 * - data-label-hide="Collapse to show only the first 6 items"
 */

document.addEventListener("DOMContentLoaded", function () {
  var buttons = document.querySelectorAll('[data-blog-toggle="true"]');

  buttons.forEach(function (btn) {
    // Get configuration from data attributes
    var config = {
      hiddenClass: btn.getAttribute("data-hidden-class") || "hidden",
      itemSelector: btn.getAttribute("data-item-selector") || '[data-item="1"]',
      indexAttr: btn.getAttribute("data-index-attr") || "data-item-index",
      textShow: btn.getAttribute("data-text-show") || "See All",
      textHide: btn.getAttribute("data-text-hide") || "Hide",
      labelShow:
        btn.getAttribute("data-label-show") || "Expand to show all items",
      labelHide:
        btn.getAttribute("data-label-hide") ||
        "Collapse to show only the first 6 items",
      maxShown: parseInt(btn.getAttribute("data-max-shown"), 10) || 6,
    };

    var root =
      btn.closest('[class*="section-"][class*="-padding"]') || document;

    function getItems() {
      return root.querySelectorAll(config.itemSelector);
    }

    function expand() {
      getItems().forEach(function (el) {
        el.classList.remove(config.hiddenClass);
      });
      btn.setAttribute("aria-expanded", "true");
      btn.textContent = config.textHide;
      btn.setAttribute("aria-label", config.labelHide);
    }

    function collapse() {
      getItems().forEach(function (el) {
        var idx = parseInt(el.getAttribute(config.indexAttr), 10) || 0;
        if (idx > config.maxShown) {
          el.classList.add(config.hiddenClass);
        }
      });
      btn.setAttribute("aria-expanded", "false");
      btn.textContent = config.textShow;
      btn.setAttribute("aria-label", config.labelShow);
    }

    // Start collapsed
    collapse();

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var expanded = btn.getAttribute("aria-expanded") === "true";
      if (expanded) {
        collapse();
        // Scroll back to the section heading for context
        var headingId = btn.getAttribute("aria-labelledby");
        if (headingId) {
          var headingIds = headingId.split(" ");
          var sectionHeadingId = headingIds.find(function (id) {
            return id.startsWith("SectionHeading-");
          });
          if (sectionHeadingId) {
            var heading = document.getElementById(sectionHeadingId);
            if (heading && heading.scrollIntoView) {
              heading.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }
        }
      } else {
        expand();
      }
    });
  });
});
